module.exports = __webpack_public_path__ + "img/user-header.4a04579c.png";